import { IApplicationState } from '../../../types';
import { PublicExpoState } from '../reducer';
import { getPublicState } from '../../selectors';

export const getPublicExpo = (state: IApplicationState): PublicExpoState =>
  getPublicState(state).expo;
